import { Col, Layout, Menu, Row, Dropdown, Grid, Select} from 'antd';
import { LogoIcon } from "../../../assets";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { MyButton, MySegmented } from "../../common";
import { getSpecialists, LANG_KEY, ROUTE_PATH } from "../../../utils";
import {useState, useEffect, useCallback} from 'react';
import { ConsultationFormModal } from '../../popups/ConsulationPopup/ConsultationPopup';
import { BurgerMenuIcon, LogIcon, ConsultationIcon } from '../../../assets/icon/common/header';
import * as S from './style';
import {useLang} from "../../../utils/context/lang";
import {useTranslation} from "react-i18next";
import { UserOutlined, QuestionCircleOutlined, LogoutOutlined,DownOutlined, UpOutlined } from '@ant-design/icons';
import {Cookies} from "react-cookie";
import { COOKIE_KEY } from '../../../utils';
import { ScreeningConsultationPopup } from '../../popups/ScreeningConsultationsPopup';
import { StyledDropdown } from './style';
import {useDispatch, useSelector} from "react-redux";
import { StyledSelect } from './style';
import { RootState, selectStore } from "../../../utils";
import { ProfileIcon, MyConsultationIcon, LogoutIcon } from '../../../assets/icon/common/header';
import { useEmbeddedNavigate, useEmbeddedLink } from '../../../utils/context/embed';
const cookies = new Cookies()

const SPECIALIST_TYPE = {
  speech_therapist: 'speech_therapist',
  defectologist: 'defectologist',
  psychologist: 'psychologist',
  educator: 'educator',
};

export const Header = () => {
  const navigate = useNavigate();
  const embeddedNavigate = useEmbeddedNavigate();
  const embeddedLink = useEmbeddedLink();
  
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isSpecialistVisible, setIsSpecialistVisible] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [screeningDropdownVisible, setScreeningDropdownVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [expandedKeys, setExpandedKeys] = useState<string[]>([]);
  const [canSelectSpecialist, setCanSelectSpecialist] = useState(false);
  const cookies = new Cookies()
  const dispatch = useDispatch();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { profile: { userData: userDataState, specialistsData: specialistsState}}: RootState = useSelector(selectStore);
  const specialists = Array.isArray(specialistsState?.data)
  ? specialistsState.data
  : [];
  const location = useLocation();
  const {handleChangeLang, lang} = useLang()
  const {t} = useTranslation("common")
  let token = cookies.get(COOKIE_KEY.ACCESS_TOKEN);
  let isScreening = cookies.get(COOKIE_KEY.IS_SCREENING);

  const isTablet = screens.md && !screens.xl && !screens.xxl;
  const getSelectedMenuKey = (pathname: string) => {
    if (pathname.startsWith('/articles')) return '/articles';
    if (pathname.startsWith('/screening')) return '/screening';
    if (pathname.startsWith('/training-cards')) return '/training-cards';
    return pathname;
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // const showModal = () => setIsModalVisible(true);

  const showModal = () => {
    setIsModalVisible(true);
    setCanSelectSpecialist(true);
  };

  const handleOk = () => setIsModalVisible(false);
  // const handleCancel = () => setIsModalVisible(false);

  const handleCancel = () => {
    setIsModalVisible(false);
    setCanSelectSpecialist(false);
  };

  const handleCancelPopup = () => setIsSpecialistVisible(false);
  const urlParams = new URLSearchParams(window.location.search);
  const isEmbed = urlParams.get('embed'); 
  const eToken = urlParams.get('etoken'); 

  const handleLogout = (embeddedNavigate: any) => {
    cookies.remove(COOKIE_KEY.ACCESS_TOKEN, { path: '/' });
    cookies.remove(COOKIE_KEY.REFRESH_TOKEN, { path: '/' });
    
    // window.location.reload()А

    embeddedNavigate('/');
  };


  const items = [
   ...((isScreening || !token)
    ? [
        {
          label: t("Screening"),
          key: ROUTE_PATH.SCREENING,
          children: [
            { label: t("selfDiagnosis"), key: ROUTE_PATH.SCREENING_TESTS_LIST },
            { label: t("earlyDevelopmentScreening"), key: ROUTE_PATH.SCREENING_WITH_SPECIALIST },
            { label: t("Neuropsychology"), key: ROUTE_PATH.SCREENING_NEURO },
            { label: t("SchoolReadinessAssessment"), key: ROUTE_PATH.SCREENING_READINESS_TESTS_LIST },
          ],
        },
      ]
    : []),
   {
      label: t("forParents"),
      key: ROUTE_PATH.ARTICLES,
      children: [
        { label: t("articles"), key: ROUTE_PATH.ARTICLES },
        { label: t("psychoPedSupport"), key: ROUTE_PATH.PSYCHO_PED_SUPPORT },
        { label: t("speech_launch_marathon"), key: ROUTE_PATH.MARATHON_LANDING },
      ],
    },
    {
      label: t("forChildren"),
      key: ROUTE_PATH.TRAINING_CARDS,
      children: [
        { label: t("trainingCards"), key: ROUTE_PATH.TRAINING_CARDS },
        { label: t("audioTales"), key: ROUTE_PATH.AUDIO_TALES },
      ],
    },
  // {
  //   label: t("articles"),
  //   key: ROUTE_PATH.ARTICLES,
  // },
  // {
  //   label: t("trainingCards"),
  //   key: ROUTE_PATH.TRAINING_CARDS,
  // },
  {
    label: t("specialists"),
    key: ROUTE_PATH.SPECIALISTS,
    children:
      specialists?.map((specialist) => ({
        label: specialist.name,
        key: `${ROUTE_PATH.SPECIALISTS}?type=${specialist.id}`,
      })) || [],
  },
];

  const menuItems = (
    <Menu style={{ fontSize: '16px' }}>
      <Menu.Item disabled style={{ fontSize: '16px' }}>
      {userDataState?.data?.first_name} {userDataState?.data?.last_name}
      </Menu.Item>
      
      <Menu.Item key="profile" icon={<ProfileIcon style={{ fontSize: '20px' }} />}>
      <Link to={embeddedLink(ROUTE_PATH.PROFILE)}>
        Профиль
        </Link>
      </Menu.Item>
      
      
      <Menu.Item key="consultations" icon={<MyConsultationIcon style={{ fontSize: '20px' }} />}>
      <Link to={embeddedLink(ROUTE_PATH.MY_CONSULTATIONS)}>
        {t("myConsultations")}
        </Link>
      </Menu.Item>
      <Menu.Item
        key="logout"
        icon={<LogoutIcon style={{ fontSize: '20px' }} />}
        onClick={() => handleLogout(embeddedNavigate)}
      >
        {t("logout")}
      </Menu.Item>
    </Menu>
  );

  // const specialistMenu = (
  //   <Menu
  //     onClick={(e) => {
  //       navigate(e.key);
  //       setDropdownVisible(false);
  //     }}
  //     items={items.find(item => item.key === ROUTE_PATH.SPECIALISTS)?.children}
  //   />
  // );

  // const specialistMenu = {
  //   items: items.find(item => item.key === ROUTE_PATH.SPECIALISTS)?.children?.map(child => ({
  //     ...child,
  //     onClick: (e) => {
  //       // navigate(child.key); 
  //       setSelectedItem(child);
  //       setIsModalVisible(true);
  //       setCanSelectSpecialist(true);
  //       // setIsSpecialistVisible(true);
  //       setDropdownVisible(false);
  //     },
  //   })),
  // };


  const specialistMenu = {
  items: items.find(item => item.key === ROUTE_PATH.SPECIALISTS)?.children?.map(child => ({
    ...child,
    onClick: () => {
      if (token) {
        if (
          userDataState?.data?.first_name &&
          userDataState?.data?.last_name &&
          userDataState?.data?.region_id
        ) {
          setSelectedItem(child);
          setIsModalVisible(true);
          setCanSelectSpecialist(false);
          setDropdownVisible(false);
        } else {
          embeddedNavigate('/register/confirm');
        }
      } else {
        embeddedNavigate('/auth');
      }
    },
  })),
};
  
  const handleExpand = (e: React.MouseEvent, key: string) => {
    e.stopPropagation();
    setExpandedKeys(prev =>
      prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]
    );
  };
  
  const menuItemsMenu = items.flatMap(item => {
  if (item.key === ROUTE_PATH.SPECIALISTS) return [];

  const isExpanded = expandedKeys.includes(item.key);

  const children = isExpanded && item.children
    ? item.children.map(child => ({
        label: <span style={{ paddingLeft: 16 }}>{child.label}</span>,
        key: child.key,
        onClick: () => {
          embeddedNavigate(child.key);
          setDropdownVisible(false);
        }
      }))
    : [];

  return [
    {
      label: (
        <span onClick={(e) => item.children && handleExpand(e, item.key)}>
          {item.label} {item.children && (isExpanded ? <UpOutlined /> : <DownOutlined />)}
        </span>
      ),
      key: item.key,
      onClick: item.children ? undefined : () => {
        embeddedNavigate(item.key);
        setDropdownVisible(false);
      }
    },
    ...children
  ];
});
  
  const menuConfig = { items: menuItemsMenu };


  const screeningMenu = (
    <Menu
      onClick={(e) => {
        embeddedNavigate(e.key);
        setScreeningDropdownVisible(false);
      }}
      items={items.find(item => item.key === ROUTE_PATH.SCREENING)?.children}
    />
  );

  const handleChangeLangSelect = useCallback((value: any) => {
    handleChangeLang(value)
  }, [])

  // const onMenuClick = (e) => navigate(e.key);

  // const onMenuClick = (e) => {
  //   const selectedSpecialist = items.find(item => 
  //     item.key === ROUTE_PATH.SPECIALISTS && 
  //     item.children?.find(child => child.key === e.key)
  //   );

  //   if (selectedSpecialist) {
  //     const specialist = selectedSpecialist.children.find(child => child.key === e.key);
  //     setSelectedItem(specialist);
  //     console.log(specialist)
  //     setIsModalVisible(true);
  //   } else {
  //     navigate(e.key)
  //   }
  // };

  const onMenuClick = (e) => {
  const selectedSpecialist = items.find(item =>
    item.key === ROUTE_PATH.SPECIALISTS &&
    item.children?.some(child => child.key === e.key)
  );

  if (selectedSpecialist) {
    if (token) {
      if (userDataState?.data?.first_name && userDataState?.data?.last_name && userDataState?.data?.region_id) {
        const specialist = selectedSpecialist.children.find(child => child.key === e.key);
        setSelectedItem(specialist);
        setIsModalVisible(true);
      } else {
        embeddedNavigate('/register/confirm');
      }
    } else {
      embeddedNavigate('/auth');
    }
  } else {
    embeddedNavigate(e.key);
  }
};

  return (
    <Layout.Header style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
      <Row justify='center'>
        <Col span={20}>
        <Row
            justify="space-between"
            align="middle"
            gutter={[screens.xs ? 0 : screens.xxl ? 16 : 8, screens.xs ? 0 : screens.xxl ? 16 : 8]}
          >
            <Col flex={1} style={{ display: 'flex', alignItems: 'center' }}>
              <S.MobileBurgerIconWrapper>
              <StyledDropdown
                menu={{
                  items: [
                    ...menuItemsMenu,
                    {
                      key: 'lang-selector',
                      label: (
                        <MySegmented
                          onChange={(value) => handleChangeLangSelect(value)}
                          value={lang}
                          options={[
                            { label: <span style={{ fontSize: 14 }}>ҚАЗ</span>, value: LANG_KEY.KZ },
                            { label: <span style={{ fontSize: 14 }}>РУС</span>, value: LANG_KEY.RU },
                            // { label: <span style={{ fontSize: 14 }}>العربية</span>, value: LANG_KEY.AR },
                            // { label: <span style={{ fontSize: 14 }}>EN</span>, value: LANG_KEY.EN },
                          ]}
                          
                        />
                      ),
                    },
                  ],
                  style: { maxWidth: '235px', minWidth: '235px', whiteSpace: 'normal', overflow: 'hidden', textOverflow: 'ellipsis' }
                }}
                trigger={['click']}
                open={dropdownVisible}
                onOpenChange={(visible) => {
                  setDropdownVisible(visible);
                  if (visible) setScreeningDropdownVisible(false);
                }}
                overlayStyle={{ fontFamily: 'Nunito' }}
                

              >
                  <S.BurgerIconWrapper>
                    <BurgerMenuIcon />
                  </S.BurgerIconWrapper>
                </StyledDropdown>
              </S.MobileBurgerIconWrapper>

              <Link to={embeddedLink(ROUTE_PATH.MAIN)} style={{ display: 'flex' }}>
                <LogoIcon style={{ width: 163, height: 32 }} />
              </Link>
            </Col>
            {!(screens.xs || isTablet) && (
              <Col flex={1}>
                <S.DesktopMenu
                  mode="horizontal"
                  items={items.filter(item => item.key !== ROUTE_PATH.SPECIALISTS)}
                  onClick={onMenuClick}
                  selectedKeys={[getSelectedMenuKey(location.pathname)]}
                  style={{ display: 'flex', alignItems: 'center' }}
                />
              </Col>
            )}
            <Col>
              <Row gutter={[screens.xs ? 8 : 16, screens.xs ? 8 : 16]} align='middle'>
                {!screens.xs && (
                  // <Col>
                  //   <MySegmented
                  //     onChange={(value) => handleChangeLangSelect(value)}
                  //     value={lang}
                  //     options={[
                  //       { label: 'ҚАЗ', value: LANG_KEY.KZ },
                  //       { label: 'РУС', value: LANG_KEY.RU },
                  //       { label: 'العربية', value: LANG_KEY.AR },
                  //       { label: 'EN', value: LANG_KEY.EN },
                  //     ]}
                  //   />
                  // </Col>

                    <Col>
                    <StyledSelect
                      value={lang}
                      onChange={(value) => handleChangeLangSelect(value)}
                      options={[
                        { label: <span style={{ fontSize: 14,fontWeight: 600 }}>ҚАЗ</span>, value: LANG_KEY.KZ },
                        { label: <span style={{ fontSize: 14,fontWeight: 600 }}>РУС</span>, value: LANG_KEY.RU },
                        // { label: <span style={{ fontSize: 14,fontWeight: 600 }}>العربية</span>, value: LANG_KEY.AR },
                        // { label: <span style={{ fontSize: 14,fontWeight: 600 }}>EN</span>, value: LANG_KEY.EN },
                      ]}
                      style={{ width: 75, height: 48, borderRadius: 20 }}

                    />
                    </Col>
                )}
                {token && (
                 <Col>
                 <Dropdown overlay={menuItems} trigger={['click']}>
                   <Row
                     style={{
                       position: 'relative',
                       background: 'rgba(255, 255, 255, 1)',
                       height: screens.xs ? 36 : 48,
                       width: screens.xs ? 36 : 48,
                       borderRadius: 12,
                       alignItems: 'center',
                       justifyContent: 'center',
                       cursor: 'pointer',
                       border: '3px solid rgba(244, 245, 247, 1)',
                     }}
                   >
                     <UserOutlined style={{ fontSize: '24px' }} />
                     {/* <Row
                       style={{
                         position: 'absolute',
                         top: isMobile ? -15 : -9,
                         right: -19,
                         background: 'rgba(255, 45, 85, 1)',
                         color: 'white',
                         borderRadius: 20,
                         height: isMobile ? 18 : 20,
                         minWidth: 20,
                         fontSize: 12,
                         alignItems: 'center',
                         justifyContent: 'center',
                         padding: '0 6px',
                       }}
                     >
                      <MyText color='rgba(255, 255, 255, 1)' size={12} weight={800}>
                        99+
                      </MyText>
                     </Row> */}
                   </Row>
                 </Dropdown>
               </Col>
                )}                 
                <Col>
                  <Row gutter={[screens.xs ? 8 : 16, screens.xs ? 8 : 16]} align='middle'>
                  {!token && (
                    screens.xs || isTablet ? (
                      <Col>
                        <LogIcon onClick={() => embeddedNavigate('/auth')} style={{ cursor: 'pointer', display: 'flex' }} />
                      </Col>
                    ) : (
                      <Col>
                        <MyButton color="blue" type="primary" onClick={() => embeddedNavigate('/auth')}>
                          {t("login")}
                        </MyButton>
                      </Col>
                    )
                  )}
                    <Col>
                      {!(screens.xs || isTablet) ? (
                        <MyButton
                          color="orange"
                          type="primary"
                          onClick={() => {
                            if (token) {
                              if (userDataState?.data?.first_name && userDataState?.data?.last_name && userDataState?.data?.region_id) {
                                showModal();
                              } else {
                                embeddedNavigate('/register/confirm');
                              }
                            } else {
                              embeddedNavigate('/auth');
                            }
                          }}
                        >
                          {t("consultation")}
                        </MyButton>
                      ) : (
                        <Col>
                        <Dropdown
                          menu={specialistMenu}
                          trigger={['click']}
                          open={screeningDropdownVisible}
                          onOpenChange={(visible) => {
                            setScreeningDropdownVisible(visible);
                            if (visible) setDropdownVisible(false); 
                          }}
                        >
                          <ConsultationIcon onClick={() => setScreeningDropdownVisible(!screeningDropdownVisible)} style={{ cursor: 'pointer', display: 'flex' }} />
                        </Dropdown>
                      </Col>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      <ConsultationFormModal visible={isModalVisible} onOk={handleOk} onCancel={handleCancel} specialists={specialists} selectedItem={selectedItem}  canSelectSpecialist={canSelectSpecialist}/>
      <ScreeningConsultationPopup
        visible={isSpecialistVisible}
        onOk={handleOk}
        onCancel={handleCancelPopup}
        selectedItem={selectedItem}
        forSpecialist={true}
      />
    </Layout.Header>
  );
};
